import { ModalHeaderWrapper } from '@features/modals/UserInfoModal/components/ModalHeaderWrapper';
import { PropsWithChildren } from 'react';
import { getContactFullName } from '@/utils/helpers';

type UserModalHeaderProps = {
  photo: string | null;
  firstName: string | null;
  lastName: string | null;
  userRole: string;
};

export const UserModalHeader = ({
  photo,
  firstName,
  lastName,
  userRole,
  children,
}: UserModalHeaderProps & PropsWithChildren) => {
  return (
    <ModalHeaderWrapper photo={photo || ''} header={getContactFullName(firstName, lastName)} subHeader={userRole}>
      {children}
    </ModalHeaderWrapper>
  );
};
